import React, { useState } from "react";

function BreakdownPage() {
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const toAddressEmail = "machinerepairsltd@outlook.com";

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.target;

        setLoading(true);

        try {
            await fetch("https://email-notifications-server.vercel.app/api/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    template: "new-breakdown-notification",
                    data: {
                        name: form.name.value,
                        email: form.email.value,
                        message: form.message.value,
                        toAddress: toAddressEmail,
                    },
                }),
            });

            form.reset();
            setSubmitted(true);
        } catch (err) {
            console.error("Form submission failed", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="flex-grow bg-gray-100 flex items-center justify-center">
            <div className="w-full max-w-4xl px-4 sm:px-6 flex flex-col items-center">
                <h2 className="text-2xl sm:text-3xl font-bold text-center mb-10">
                    Report a Breakdown
                </h2>
                <p className="max-w-md text-center mb-6 text-gray-700">
                    Experiencing a machine issue? Fill out the form below and we’ll get back to you as soon as possible. Or email us directly at {" "}
                    <a
                        href="mailto:machinerepairsltd@outlook.com"
                        className="text-blue-600 hover:underline"
                    >
                        machinerepairsltd@outlook.com
                    </a>.
                </p>

                {submitted ? (
                    <div className="max-w-md w-full bg-green-100 border border-green-300 text-green-800 rounded-lg p-4 text-center">
                        ✅ Thanks for getting in touch!
                        <br />
                        We’ve received your message and will respond shortly.
                    </div>
                ) : (
                    <form
                        className="max-w-md w-full space-y-4 sm:space-y-6"
                        onSubmit={handleSubmit}
                    >
                        <input
                            name="name"
                            type="text"
                            placeholder="Your Name"
                            className="w-full border border-gray-300 rounded-lg px-4 py-3"
                            required
                        />

                        <input
                            name="email"
                            type="email"
                            placeholder="Your Email"
                            className="w-full border border-gray-300 rounded-lg px-4 py-3"
                            required
                        />

                        <textarea
                            name="message"
                            placeholder="Your Message"
                            className="w-full border border-gray-300 rounded-lg px-4 py-3 h-32"
                            required
                        />

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-semibold px-6 py-3 rounded-lg"
                        >
                            {loading ? "Sending..." : "Send Message"}
                        </button>
                    </form>
                )}
            </div>
        </section>
    );
}

export default BreakdownPage;
